import React, { useCallback } from 'react';
import { useArtboardContext, CONTEXT_KEYS } from '../../context/complexArtboardContext'
import { TabMenuItemContainer, IconMenuItem } from '../SidebarMenu/styles';
import EditorElement from '../../components/EditorElement';
import { useTranslation } from 'react-i18next';
import { COMPLEX_DESIGN_ELEMENTS } from '../ComplexDocumentDesign/translationValues';
import { FREE_HAND_TEXT_ELEMENTS } from '../../utils/API/translationValues';
import { FREE_HAND_TEXT_ELEMENTS as trans } from '../../utils/masterElements/translationValues';

const elements = (t, currentLanguage = 'en', currentDesign) => {
  console.log("Lets design tab :: ", currentLanguage, currentDesign);
    return [
    {
      id: 1,
      name: 'text',
      icon: 'font-size',
      displayName: t(FREE_HAND_TEXT_ELEMENTS.TEXT_ELEMENT_TITLE.key, FREE_HAND_TEXT_ELEMENTS.TEXT_ELEMENT_TITLE.value),
      thumbnail: '',
      type: 'text',
      elementDetails: {
        style: {},
        type: 'text',
        variableContract: [],
        contents: [
          {
            contentType: 'PARAGRAPH',
            style: {
              fontWeight: [],
              color: '#000000'
            },
            content: t(trans.PARAGRAPH_TEXT.key, trans.PARAGRAPH_TEXT.value)
          },
          {
            contentType: "LINE_BREAK",
            style: {
              lineSpacing: 1.5
            }
          }
        ],
        blockType: 'text',
      }
    },
    {
      id: 2,
      name: 'creative',
      icon: 'highlight',
      displayName: t(FREE_HAND_TEXT_ELEMENTS.GRAPHIC_IMAGE_TITLE.key, FREE_HAND_TEXT_ELEMENTS.GRAPHIC_IMAGE_TITLE.value),
      thumbnail: '',
      type: 'creative',
      elementDetails: {
        style: {
          height: 100,
        },
        variableContract: [],
        contents: [],
        type: 'creative',
        blockType: 'creative',
      },
    },
    {
      id: 3,
      name: 'button',
      icon: 'link',
      displayName: t(FREE_HAND_TEXT_ELEMENTS.BUTTON_LINKS_TITLE.key, FREE_HAND_TEXT_ELEMENTS.BUTTON_LINKS_TITLE.value),
      thumbnail: '',
      type: 'button',
      elementDetails: {
        style: {
          padding: {top: 9, bottom: 9, left: 9, right: 9},
          alignment: 'center',
          linkStyles: {
            type: 'web',
            innerPadding: '10px 25px 10px 25px',
            buttonBg: 'rgb(6,14,131)',
            borderRadius: '5px',
            bgGradient: 'linear-gradient(0deg, rgba(6,14,131,1) 0%, rgba(12,25,180,1) 100%)',
            boxShadow:
              'inset 2px 2px 2px 0px rgba(255,255,255,.5), 7px 7px 20px 0px rgba(0,0,0,.1), 4px 4px 5px 0px rgba(0,0,0,.1)',
            contents: [{
              content: '',
              contentType: "PARAGRAPH",
              style: {
                color: "#000000",
              },
            },
            {
              contentType: "LINE_BREAK",
              style: {
                lineSpacing: 1.5
              }
            }]
          },
        },
        variableContract: [],
        contents: [{
          content: 'Read more!!',
          contentType: "PARAGRAPH",
          style: {
            color: "#FFFFFF",
          },
        },
        {
          contentType: "LINE_BREAK",
          style: {
            lineSpacing: 1.5
          }
        }],
        type: 'button',
        blockType: 'button',
      },
    },
    {
      id: 4,
      name: 'link',
      icon: 'team',
      displayName:  t(FREE_HAND_TEXT_ELEMENTS.SOCIAL_MEDIA_TITLE.key, FREE_HAND_TEXT_ELEMENTS.SOCIAL_MEDIA_TITLE.value),
      thumbnail: '',
      type: 'link',
      elementDetails: {
        style: {
          spacing: 30,
          width: 30,
          backgroundColor: 'rgb(136, 133, 133)',
          padding: {top: 20, bottom: 20, left: 20, right: 20},
          alignment: 'center'
        },
        variableContract: [],
        contents: [
          {
            contentType: 'FACEBOOK',
            contents: [
              {
                content: 'https://facebook.com',
                contentType: 'PARAGRAPH',
                style: {
                  color: '#000000',
                },
              },
            ],
          },
          {
            contentType: 'LINKEDIN',
            contents: [
              {
                content: 'https://linkedIn.com',
                contentType: 'PARAGRAPH',
                style: {
                  color: '#000000',
                },
              },
            ],
          },
          {
            contentType: 'INSTAGRAM',
            contents: [
              {
                content: '\n',
                contentType: 'LINE_BREAK',
                style: {
                  color: '#000000',
                },
              },
            ],
          },
          {
            contentType: 'TWITTER',
            contents: [
              {
                content: 'https://twitter.com',
                contentType: 'PARAGRAPH',
                style: {
                  color: '#000000',
                },
              },
            ],
          },
          {
            contentType: 'WHATSAPP',
            contents: [
              {
                content: '\n',
                contentType: 'LINE_BREAK',
                style: {
                  color: '#000000',
                },
              },
            ],
          },
        ],
        type: 'link',
        blockType: 'link',
      }
    },
    {
      id: 5,
      name: 'repetitive',
      icon: 'block',
      displayName: t(COMPLEX_DESIGN_ELEMENTS.REPETITIVE_BLOCK_LABEL.key, COMPLEX_DESIGN_ELEMENTS.REPETITIVE_BLOCK_LABEL.value),
      thumbnail: '',
      type: 'creative',
      elementDetails: {
        style: {
          height: 100,
        },
        variableContract: [{
          name: undefined,
          type: 'object',
          content: []
        }],
        contents: [],
        type: 'creative',
        blockType: 'creative',
      },
    },
    {
      id: 5,
      name: 'dynamicTable',
      icon: 'table',
      displayName: t(COMPLEX_DESIGN_ELEMENTS.DYNAMIC_TABLE_BLOCK_LABEL.key, COMPLEX_DESIGN_ELEMENTS.DYNAMIC_TABLE_BLOCK_LABEL.value),
      thumbnail: '',
      type: 'creative',
      elementDetails: {
        type: "dynamic_table",
        blockType: "dynamic_table",
        variableContract: [
          {
            name: undefined,
            type: "object",
            content: []
          }
        ],
        style: {
          border: {
            thickness: 1,
            borderStyle: "SOLID",
            borderColor: "#000000",
            top: false,
            right: false,
            left: false,
            bottom: false
          },
          padding: {
            left: 5,
            right: 5,
            top: 5,
            bottom: 5
          },
          tableProperties: {
            showHeader: true,
            showHeaderOnAllPages: true,
            showTopBlock: false,
            topBlock: undefined,
            showBottomBlock: false,
            bottomBlock: undefined,
            showtopBlockOnAllPages: false,
            emptyText: [
              {
                contentType: 'PARAGRAPH',
                style: {
                  lineSpacing: 1.5,
                  fontWeight: [],
                  color: '#000000'
                },
                content: ''
              },
              {
                contentType: "LINE_BREAK",
                style: {
                  lineSpacing: 1.5,
                  fontWeight: [],
                  color: '#000000'
                }
              }
            ],
          },
        },
        contents: [
            {
              groupHeaderContent: {
                contentType: "text",
                columnSpan: 1,
                style: {
                  width: 50,
                  border: {
                    thickness: 1,
                    borderStyle: "SOLID",
                    borderColor: "#000000",
                    top: true,
                    right: true,
                    left: true,
                    bottom: true
                  },
                  padding: {
                      left: 2,
                      right: 2,
                      top: 2,
                      bottom: 2
                  }
                },
                contents: [
                  {
                    contentType: "LINE_BREAK",
                    content: "\n",
                    style: {
                      alignment: "center",
                      lineSpacing: 1.5
                    }
                  }
                ]
              },
              headerContent: {
                contentType: "text",
                style: {
                  width: 50,
                  border: {
                    thickness: 1,
                    borderStyle: "SOLID",
                    borderColor: "#000000",
                    top: true,
                    right: true,
                    left: true,
                    bottom: true
                  },
                  padding: {
                      left: 2,
                      right: 2,
                      top: 2,
                      bottom: 2
                  }
                },
                contents: [
                  {
                    contentType: "PARAGRAPH",
                    content: t(COMPLEX_DESIGN_ELEMENTS.DYNAMIC_TABLE_DEFAULT_HEADER.key, COMPLEX_DESIGN_ELEMENTS.DYNAMIC_TABLE_DEFAULT_HEADER.value, { index: 1 }),
                    style: {
                      fontWeight: [],
                      color: '#000000'
                    }
                  },
                  {
                    contentType: "LINE_BREAK",
                    content: "\n",
                    style: {
                      alignment: "center",
                      lineSpacing: 1.5
                    }
                  }
                ]
              },
              content: {
                contentType: "text",
                style: {
                  width: 50,
                  border: {
                    thickness: 1,
                    borderStyle: "SOLID",
                    borderColor: "#000000",
                    top: true,
                    right: true,
                    left: true,
                    bottom: true
                  },
                  padding: {
                    left: 2,
                    right: 2,
                    top: 2,
                    bottom: 2
                  }
                },
                contents: [
                 {
                   contentType: 'PARAGRAPH',
                   style: {
                     lineSpacing: 1.5,
                     fontWeight: [],
                     color: '#000000'
                   },
                   content: ' '
                 },
                 {
                   contentType: "LINE_BREAK",
                   content: "\n",
                   style: {
                     lineSpacing: 1.5,
                     alignment: "center",
                     color: "#000000"
                   }
                 }]
              }
            },
            {
              groupHeaderContent: {
                contentType: "text",
                columnSpan: 1,
                style: {
                  width: 50,
                  border: {
                    thickness: 1,
                    borderStyle: "SOLID",
                    borderColor: "#000000",
                    top: true,
                    right: true,
                    left: true,
                    bottom: true
                  },
                  padding: {
                      left: 2,
                      right: 2,
                      top: 2,
                      bottom: 2
                  }
                },
                contents: [
                  {
                    contentType: "LINE_BREAK",
                    content: "\n",
                    style: {
                      alignment: "center",
                      lineSpacing: 1.5
                    }
                  }
                ]
              },
              headerContent: {
                contentType: "text",
                style: {
                  width: 50,
                  border: {
                    thickness: 1,
                    borderStyle: "SOLID",
                    borderColor: "#000000",
                    top: true,
                    right: true,
                    left: true,
                    bottom: true
                  },
                  padding: {
                      left: 2,
                      right: 2,
                      top: 2,
                      bottom: 2
                  }
                },
                contents: [
                  {
                    contentType: "PARAGRAPH",
                    content: t(COMPLEX_DESIGN_ELEMENTS.DYNAMIC_TABLE_DEFAULT_HEADER.key, COMPLEX_DESIGN_ELEMENTS.DYNAMIC_TABLE_DEFAULT_HEADER.value, { index: 2 }),
                    style: {
                      fontWeight: [],
                      color: '#000000'
                    }
                  },
                  {
                    contentType: "LINE_BREAK",
                    content: "\n",
                    style: {
                      alignment: "center",
                      lineSpacing: 1.5
                    }
                  }
                ]
              },
              content: {
                contentType: "text",
                style: {
                  width: 50,
                  border: {
                    thickness: 1,
                    borderStyle: "SOLID",
                    borderColor: "#000000",
                    top: true,
                    right: true,
                    left: true,
                    bottom: true
                  },
                  padding: {
                    left: 2,
                    right: 2,
                    top: 2,
                    bottom: 2
                  }
                },
                contents: [
                 {
                   contentType: 'PARAGRAPH',
                   style: {
                     lineSpacing: 1.5,
                     fontWeight: [],
                     color: '#000000'
                   },
                   content: ' '
                 },
                 {
                   contentType: "LINE_BREAK",
                   content: "\n",
                   style: {
                     lineSpacing: 1.5,
                     alignment: "center",
                     color: "#000000"
                   }
                 }]
              }
            }
        ]
      }
    }
  ];
};

const NAMESPACES = ['COMPLEX_DESIGN_ELEMENTS', 'FREE_HAND_TEXT_ELEMENTS'];

const LetsDesignTabDetails = (props) => {
  const { currentDesign } = props;
  const { t, i18n } = useTranslation(NAMESPACES);

  const customArtboardSelector = useCallback(store => store[CONTEXT_KEYS.CURRENT_BLOCK] === '', []);
  const [draggable] = useArtboardContext(customArtboardSelector, `LetsDesignTabDetails`);
  
  let LetsDesignTabElements = elements(t, i18n.language, currentDesign).filter(el => {
    return true;
  });

  return (
    <TabMenuItemContainer columnDirection={false}>
        {LetsDesignTabElements?.map(element => (
          <IconMenuItem key={element.id} className='mailElements'>
            <EditorElement
               element={element}
               clickElement={() => {}}
               toggleDragging={() => {}}
               pageSettings={{}}
               setIsDragAndDropped={() => {}}
               type={element.type}
               draggable={draggable}
             />
          </IconMenuItem>
        ))}
    </TabMenuItemContainer>
  )
}

export default LetsDesignTabDetails;